export const atlas_root_dir = '/static/data/images/';
export const alt_src = '/static/images/capture/blue_cwa_logo_string_eng.png'
export const white_src = '/static/images/capture/white_cwa_logo_string_eng.png'

// WRA ---------------------------------------------------------------------------------------------------------------------


// EC 日雨量
export const EC_taiwan_daily_rain_images_dir = 'wra/daily/OBS/';

// 所有圖輯
export const data_list = [
    // WRA
    {
        image_type: 1,
        name: '日雨量_ECMWF HRES',
        data_template: [
            {
                tag: 'title',
                text: '歐洲中期天氣預報中心(ECMWF)'
            },
            {
                tag: 'subtitle',
                titles: ['高解析大氣模式(HRES)'],
                title_en: 'Atmospheric Model high resolution',
                update_messages: ['每日上午更新', '解析度10公里 9天預報']
            },
            {
                tag: 'date-table',
                row_date_count: 12,
                column_date_count: 6,
                images_dir: 'wra/daily/ECMWF/',
                file_name: {
                    rule: 'year_date_pre_index_suf',
                    prefix: '_ec_prcp_d',
                    suffix: '_TW2_12z',
                    type: 'png'
                },
                compression: true
            },
        ]
    },
    {
        image_type: 2,
        name: '日雨量_CWA/GFS單一模式',
        data_template: [
            {
                tag: 'title',
                text: '中央氣象署(CWA)'
            },
            {
                tag: 'subtitle',
                titles: ['決定性(deterministic)預報(單一模式)'],
                title_en: '',
                update_messages: ['每日上午更新', '解析度15公里 16天預報']
            },
            {
                tag: 'date-table',
                row_date_count: 19,
                column_date_count: 10,
                images_dir: 'wra/daily/CWBdet',
                file_name: {
                    rule: 'year_date_pre_index_suf',
                    prefix: '_CWB_prcp_d',
                    suffix: '_TW2_12z',
                    type: 'png'
                },
                compression: false
            },
        ]
    },
    {
        image_type: 3,
        name: '日雨量_CWA/GFS多模式平均',
        data_template: [
            {
                tag: 'title',
                text: '中央氣象署(CWA)'
            },
            {
                tag: 'subtitle',
                titles: ['系集(Ensemble)預報(多模式平均)'],
                title_en: '',
                update_messages: ['每日上午更新', '解析度40公里 16天預報 21個系集成員']
            },
            {
                tag: 'date-table',
                row_date_count: 19,
                column_date_count: 10,
                images_dir: 'wra/daily/CWBens',
                file_name: {
                    rule: 'year_date_pre_index_suf',
                    prefix: '_CWBens_prcp_d',
                    suffix: '_TW2_00z',
                    type: 'png'
                },
                compression: false
            },
        ]
    },
    {
        image_type: 4,
        name: '週雨量_CWA',
        grid_dir: [
            'wra/weekly/CWBpm4weeks/', 
            'wra/weekly/CWBprob4weeks/'
        ],
        data_template: [
            {
                tag: 'title',
                text: '中央氣象署(CWA)'
            },
            {
                tag: 'subtitle',
                titles: ['未來1-4週逐週的機率擬合(PM)降雨預報(偏差修正)', '原始模式來源 ECMWF'],
                title_en: '',
                update_messages: ['每日下午9點後更新', '解析度1公里']
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_PM_W01-04_SPP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    }
                ]
            },
            {
                tag: 'title',
                text: '中央氣象署(CWA)'
            },
            {
                tag: 'subtitle',
                titles: ['未來1-4週逐週的系集降雨機率預報(偏差修正)'],
                title_en: '',
                update_messages: ['每日下午9點後更新', '解析度1公里']
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_Prob_W01-04_SPP',
                        dir_index: 1,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    }
                ]
            }
        ]
    },
    {
        image_type: 29,
        name: '週雨量_CWA-展期(1-14天)7日累積雨量',
        grid_dir: [
            'wra/weekly/CWBpm14days/', 
            'wra/weekly/CWBprob14days/'
        ],
        data_template: [
            {
                tag: 'title',
                text: '中央氣象署(CWA)'
            },
            {
                tag: 'subtitle',
                titles: ['未來1-14天逐日的週累積機率擬合偏差修正(PM)降雨預報', '原始模式來源 ECMWF'],
                title_en: '',
                update_messages: ['每日下午5點後更新', '解析度1公里']
            },
            {
                tag: 'grid',
                grid: 8,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_PM_D01-D07_SPP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: 'D01-D07'
                    },
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_PM_D02-D08_SPP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: 'D02-D08'
                    },
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_PM_D03-D09_SPP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: 'D03-D09'
                    },
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_PM_D04-D10_SPP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: 'D04-D10'
                    },
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_PM_D05-D11_SPP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: 'D05-D11'
                    },
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_PM_D06-D12_SPP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: 'D06-D12'
                    },
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_PM_D07-D13_SPP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: 'D07-D13'
                    },
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_PM_D08-D14_SPP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: 'D08-D14'
                    },
                ]
            },
            {
                tag: 'annotation',
                hide: true,
                text: '註「*點擊"註"可得到詳細說明」',
                list: ['PM和系集平均一樣可濾掉非線性誤差的雨量型態分布 (rainfall pattern)，但有更接近真實的降雨率。PM方法主要是針對系集平均容易低估降雨極值的缺點進行改進，其假設系集平均的降雨分布是正確的，但認為納入所有成員在所有格點上的降雨頻率分布才會接近真實的降雨頻率分布。', 'PM的產製過程如下：假定所採用的系集預報系統有20個成員，首先，將20個成員在所有模式格點之降雨預報進行排序，並以20個降雨預報為一組，計算此組降雨預報的中位數，再將各組的中位數依序填入系集平均的降雨空間分布。舉例說明，PM最大的降雨預報中位數值將被填入系集平均空間分布中最大降雨預報的格點位置，排名第2的降雨預報值則是填入系集平均空間分布中第2高降雨的格點位置，以此類推。PM藉此雨量重新配置過程，得到與系集平均相同的降雨型態分布，但保留了降雨極值，改善系集平均之降雨極值被平滑掉的問題。', '進行PM之前已經進行過雨量位置的校正，如此可確保展期降雨預報的PM更具參考價值。'],
            },
            {
                tag: 'title',
                text: '中央氣象署(CWA)'
            },
            {
                tag: 'subtitle',
                titles: ['未來1-14天逐日的週累積雨量系集機率預報(偏差修正)'],
                title_en: '',
                update_messages: ['每日下午5點後更新', '解析度1公里']
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_Prob_Lead01-08_SPP',
                        dir_index: 1,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    }
                ]
            },
            {
                tag: 'annotation',
                hide: true,
                text: '註「*點擊"註"可得到詳細說明」',
                image: {
                    alt: '月雨量趨勢說明',
                    src: '/static/images/product/atlas_description/weeklyCwbProb.png'
                }
            }
        ]
    },
    {
        image_type: 30,
        name: 'CWA-展期(1-9天)3日累積雨量',
        grid_dir: [
            'wra/weekly/CWApm9days/', 
            'wra/weekly/CWAprob9days/'
        ],
        data_template: [
            {
                tag: 'title',
                text: '中央氣象署(CWA)'
            },
            {
                tag: 'subtitle',
                titles: ['未來1-9天逐日的三日 累積機率擬合偏差修正(PM)降雨預報', '原始模式來源 ECMWF'],
                title_en: '',
                update_messages: ['每日下午5點後更新', '解析度1公里']
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_PM_Lead01-07_SPP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    }
                ]
            },
            {
                tag: 'annotation',
                hide: true,
                text: '註「*點擊"註"可得到詳細說明」',
                list: ['待補充'],
            },
            {
                tag: 'title',
                text: '中央氣象署(CWA)'
            },
            {
                tag: 'subtitle',
                titles: ['未來1-9天逐日的三日 累積雨量系集機率預報(偏差修正)'],
                title_en: '',
                update_messages: ['每日下午5點後更新', '解析度1公里']
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: '',
                        suffix: '_Prob_Lead01-07_SPP',
                        dir_index: 1,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    }
                ]
            }
        ]
    },
    {
        image_type: 5,
        name: '週雨量_ECMWF',
        grid_dir: ['wra/weekly/ECMWFdet/', 'wra/weekly/ECMWFens/'],
        data_template: [
            {
                tag: 'title',
                text: '歐洲中期天氣預報中心(ECMWF)'
            },
            {
                tag: 'subtitle',
                titles: ['EC高解析'],
                title_en: 'Atmospheric Model high resolution',
                update_messages: ['每日上午更新', '解析度10公里']
            },
            {
                tag: 'grid',
                grid: 6,
                images: [
                    {
                        src:  '',
                        rule: 'date_pre_hour_suf',
                        prefix: '_ec_prcp_w1_TW2_',
                        suffix: 'z',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '第1週雨量'
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['EC系集'],
                title_en: 'Atmospheric model Ensemble extended',
                update_messages: ['每週2、5上午更新', '解析度40公里 51個系集成員']
            },
            {
                tag: 'grid-bind',
                grid: 6,
                images: [
                    [
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcp_w1_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第1週雨量'
                        },
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcpAno_w1_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第1週雨量距平'
                        }
                    ],
                    [
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcp_w2_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第2週雨量'
                        },
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcpAno_w2_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第2週雨量距平'
                        }
                    ],
                    [
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcp_w3_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第3週雨量'
                        },
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcpAno_w3_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第3週雨量距平'
                        }
                    ],
                    [
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcp_w4_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第4週雨量'
                        },
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcpAno_w4_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第4週雨量距平'
                        }
                    ],
                    [
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcp_w5_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第5週雨量'
                        },
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcpAno_w5_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第5週雨量距平'
                        }
                    ],
                    [
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcp_w6_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第6週雨量'
                        },
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_ECens1_prcpAno_w6_TW2_',
                            suffix: 'z',
                            dir_index: 1,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第6週雨量距平'
                        }
                    ]
                ]
            },
        ]
    },
    {
        image_type: 6,
        name: '週雨量_NCEP',
        grid_dir: ['wra/weekly/NCEPens/'],
        data_template: [
            {
                tag: 'title',
                text: '美國國家環境預報中心(NCEP)'
            },
            {
                tag: 'subtitle',
                titles: ['美國國家環境預報中心 全球系集預報系統(NCEP GEFS V12)'],
                update_messages: ['每日上午更新(3、4週預報更新時間較晚)', '解析度50公里 30個系集成員']
            },
            {
                tag: 'grid-bind',
                grid: 4,
                images: [
                    [
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_NCEPgefs_prcp_w1_TW2_',
                            suffix: 'z',
                            dir_index: 0,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第1週雨量'
                        },
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_NCEPgefs_prcpAno_w1_TW2_',
                            suffix: 'z',
                            dir_index: 0,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第1週雨量距平'
                        }
                    ],
                    [
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_NCEPgefs_prcp_w2_TW2_',
                            suffix: 'z',
                            dir_index: 0,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第2週雨量'
                        },
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_NCEPgefs_prcpAno_w2_TW2_',
                            suffix: 'z',
                            dir_index: 0,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第2週雨量距平'
                        }
                    ],
                    [
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_NCEPgefs_prcp_w3_TW2_',
                            suffix: 'z',
                            dir_index: 0,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第3週雨量'
                        },
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_NCEPgefs_prcpAno_w3_TW2_',
                            suffix: 'z',
                            dir_index: 0,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第3週雨量距平'
                        }
                    ],
                    [
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_NCEPgefs_prcp_w4_TW2_',
                            suffix: 'z',
                            dir_index: 0,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第4週雨量'
                        },
                        {
                            src:  '',
                            rule: 'date_pre_hour_suf',
                            prefix: '_NCEPgefs_prcpAno_w4_TW2_',
                            suffix: 'z',
                            dir_index: 0,
                            type: 'png',
                            failed: false,
                            alt_image: alt_src,
                            header_content: '第4週雨量距平'
                        }
                    ],
                ]
            },
        ]
    },
    {
        image_type: 7,
        name: '月雨量_CWA',
        grid_dir: ['Frdc_wra/prcp_monthly/'],
        data_template: [
            {
                tag: 'title',
                text: '中央氣象署(CWA)'
            },
            {
                tag: 'subtitle',
                titles: ['第一代海氣偶合模式(CFSv1.1)月雨量3分類機率預報'],
                title_en: '',
                update_messages: ['每月下旬更新', '解析度110公里 280天預報 30個系集成員']
            },
            {
                tag: 'grid',
                grid: 6,
                images: [
                    {
                        src:  '',
                        rule: 'pre_year_middle_month_suf',
                        prefix: 'fcst',
                        middle: '-ini',
                        suffix: '-Precipitation-16sta-membclu1mn-lead0',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第1個月'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_middle_month_suf',
                        prefix: 'fcst',
                        middle: '-ini',
                        suffix: '-Precipitation-16sta-membclu1mn-lead1',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第2個月'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_middle_month_suf',
                        prefix: 'fcst',
                        middle: '-ini',
                        suffix: '-Precipitation-16sta-membclu1mn-lead2',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第3個月'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_middle_month_suf',
                        prefix: 'fcst',
                        middle: '-ini',
                        suffix: '-Precipitation-16sta-membclu1mn-lead3',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第4個月'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_middle_month_suf',
                        prefix: 'fcst',
                        middle: '-ini',
                        suffix: '-Precipitation-16sta-membclu1mn-lead4',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第5個月'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_middle_month_suf',
                        prefix: 'fcst',
                        middle: '-ini',
                        suffix: '-Precipitation-16sta-membclu1mn-lead5',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第6個月'
                    }
                ]
            },
            {
                tag: 'help-icon',
                image: {
                    alt: '月雨量趨勢說明',
                    src: '/static/images/product/atlas_description/descriptionMonthlyRainfall.png',
                    width: '80%'
                }
            },
        ]
    },
    {
        image_type: 25,
        name: '月雨量_ECMWF水庫集水區',
        grid_dir: ['wra/monthly/ECMWF/'],
        data_template: [
            {
                tag: 'title',
                text: '歐洲中期天氣預報中心(ECMWF)'
            },
            {
                tag: 'subtitle',
                titles: [],
                title_en: '',
                update_messages: ['模式解析度為0.4度，預報時間長度為7個月，51個系集成員']
            },
            {
                tag: 'grid',
                grid: 7,
                images: [
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'SEAS5_',
                        middle: '',
                        suffix: '_lead0_6cluster_pie_qmap_EP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '當月預報'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'SEAS5_',
                        middle: '',
                        suffix: '_lead1_6cluster_pie_qmap_EP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第1個月'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'SEAS5_',
                        middle: '',
                        suffix: '_lead2_6cluster_pie_qmap_EP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第2個月'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'SEAS5_',
                        middle: '',
                        suffix: '_lead3_6cluster_pie_qmap_EP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第3個月'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'SEAS5_',
                        middle: '',
                        suffix: '_lead4_6cluster_pie_qmap_EP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第4個月'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'SEAS5_',
                        middle: '',
                        suffix: '_lead5_6cluster_pie_qmap_EP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第5個月'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'SEAS5_',
                        middle: '',
                        suffix: '_lead6_6cluster_pie_qmap_EP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第6個月'
                    }
                ]
            },
            {
                tag: 'help-icon',
                image: {
                    alt: '月雨量趨勢說明',
                    src: '/static/images/product/atlas_description/descriptionMonthlyRainfallEcmwf.jpg'
                }
            },
            {
                tag: 'grid-padding',
                grid: 1,
                images:[
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'SEAS5_',
                        middle: '',
                        suffix: '_6cluster_sheet_qmap_EP',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src
                    }
                ]
            },
            {
                tag: 'btn-area',
                image: {
                    alt: '月雨量趨勢說明',
                    src: '/static/images/product/atlas_description/description-wra-reservoir-rain-forecast-monthly-ecmwf.png'
                }
            }
        ]
    },
    {
        image_type: 31,
        name: '月雨量_ECMWFECMWF東亞區域',
        grid_dir: ['wra/monthly/EastAsia/'],
        data_template: [
            {
                tag: 'title',
                text: '歐洲中期天氣預報中心(ECMWF)'
            },
            {
                tag: 'subtitle',
                titles: [],
                title_en: '',
                update_messages: ['東亞區域雨量預報，模式解析度為0.4度，預報時間長度為7個月，51個系集成員']
            },
            {
                tag: 'grid',
                grid: 3,
                images: [
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: '',
                        middle: '',
                        suffix: '_pcp_mn_lag1_tw',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第1個月距平場'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: '',
                        middle: '',
                        suffix: '_pcp_mn_lag2_tw',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第2個月距平場'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: '',
                        middle: '',
                        suffix: '_pcp_mn_lag3_tw',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第3個月距平場'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'Prob1mn_',
                        middle: '',
                        suffix: '_pcp_lag1_tw',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第1個月三分類機率預報'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'Prob1mn_',
                        middle: '',
                        suffix: '_pcp_lag2_tw',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第2個月三分類機率預報'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'Prob1mn_',
                        middle: '',
                        suffix: '_pcp_lag3_tw',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '未來第3個月三分類機率預報'
                    }
                ]
            }
        ]
    },
    {
        image_type: 9,
        name: '未來兩週降雨分析',
        grid_dir: ['wra/summary/'],
        data_template: [
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: 'wra_prcp_',
                        middle: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src
                    }
                ]
            },
            {
                tag: 'note',
                text: '每週5更新'
            },
        ]
    },
    {
        image_type: 24,
        name: '短期定量降水預報_iQPF',
        data_template: [
            {
                tag: 'title',
                text: '中央氣象署(CWA)'
            },
            {
                tag: 'link',
                text: '連結到 iQPF',
                href: 'https://mfcqpf.cwa.gov.tw/'
            }
        ]
    },
    {
        image_type: 8,
        name: '日雨量趨勢',
        grid_dir: [
            'wra/timeseries/ECMWF/', 
            'wra/timeseries/ECMWFlag/', 
            'wra/timeseries/NCEP/', 
            'wra/timeseries/NCEPlag/'
        ],
        data_template: [
            {
                tag: 'title-left-right',
                text_left: '歐洲中期天氣預報中心(ECMWF)',
                text_right: '美國國家環境預報中心(NCEP)'
            },
            {
                tag: 'subtitle-left-right',
                titles_left: ['系集預報系統(ECENS)'],
                title_en_left: 'Atmospheric model Ensemble extended',
                update_messages_left: ['每週2、5上午更新', '解析40公里 45天預報 51個系集成員'],
                titles_right: ['全球系集預報系統(GEFS v12)'],
                title_en_right: 'Global Ensemble Forecast System v12',
                update_messages_right: ['每日上午更新 1至35天的預報更新時間較晚', '解析度50公里 35天預報 30個系集成員'],
            },
            {
                tag: 'header-fill',
                text: '2週時序圖'
            },
            {
                tag: 'grid-left-right',
                images_left: [
                    {
                        src:  '',
                        rule: 'date_pre_hour_suf',
                        prefix: '_ECens_prcp2W_tser_',
                        middle: '',
                        suffix: 'z',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    },
                    {
                        src:  '',
                        rule: 'date_pre_hour_suf',
                        prefix: '_ECens_prcp2W_LagTser_',
                        middle: '',
                        suffix: 'z',
                        dir_index: 1,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    }
                ],
                images_right: [
                    {
                        src:  '',
                        rule: 'date_pre_hour_suf',
                        prefix: '_NCEPgefs_prcp_tser_',
                        middle: '',
                        suffix: 'z',
                        dir_index: 2,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    },
                    {
                        src:  '',
                        rule: 'date_pre_hour_suf',
                        prefix: '_NCEPgefs_prcp_LagTser_',
                        middle: '',
                        suffix: 'z',
                        dir_index: 3,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    }
                ]
            },
            {
                tag: 'header-fill',
                text: '5或6週時序圖'
            },
            {
                tag: 'grid-left-right',
                images_left: [
                    {
                        src:  '',
                        rule: 'date_pre_hour_suf',
                        prefix: '_ECens_prcp_tser_',
                        middle: '',
                        suffix: 'z',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    },
                    {
                        src:  '',
                        rule: 'date_pre_hour_suf',
                        prefix: '_ECens_prcp_LagTser_',
                        middle: '',
                        suffix: 'z',
                        dir_index: 1,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    }
                ],
                images_right: [
                    {
                        src:  '',
                        rule: 'date_pre_hour_suf',
                        prefix: '_NCEPgefs_prcp35d_tser_',
                        middle: '',
                        suffix: 'z',
                        dir_index: 2,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    },
                    {
                        src:  '',
                        rule: 'date_pre_hour_suf',
                        prefix: '_NCEPgefs_prcp35d_LagTser_',
                        middle: '',
                        suffix: 'z',
                        dir_index: 3,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                    }
                ]
            },
            {
                tag: 'help-icon',
                image: {
                    alt: '日雨量趨勢說明',
                    src: '/static/images/product/atlas_description/descriptionDailyRainfallTrend.png'
                }
            }
        ]
    },
    {
        image_type: 23,
        name: '三小時累積雨量預報',
        data_template: [
            {
                tag: 'time-select-table',
                text: '三小時累積雨量預報',
                titles: ["06-09", "09-12", "12-15", "15-18", "18-21", "21-24", "24-27", "27-30", "30-33", "33-36", "36-39", "39-42", "42-45", "45-48"],
                // custom_title
                kind: ['ECMWF', 'WRFD', 'TWRF', 'WEPS-NPM'],
                custom_kind: ['ECMWF', 'WRFD', 'TWRF', 'WEPSNPM'],
                path_use_kind: true,
                dir: 'wra/short3hr/',
                prefix: '00f0',
                select_rule: 'UTC',
                title_rule: 'initial-real',
                path_rule: 'date_time-pre-title',
                type: 'webp',
                label: 'Initial Time',
                data_class: 'select-label-bold'
            },
        ]
    },

    // CGA
    {
        image_type: 17,
        name: '一週地面天氣圖',
        grid_dir: ['composite_fig/sfc/'],
        use_fulldate: true,
        data_template: [
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: 'NCEP_NAGRID_CGA_',
                        suffix: '_A01',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ]
    },
    {
        image_type: 18,
        name: '一週風力報表_台灣至沖之島',
        grid_dir: ['composite_fig/wind/PV/'],
        use_fulldate: true,
        data_template: [
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: 'NCEP_NAGRID_PV_',
                        suffix: '_AR2',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ]
    },
    {
        image_type: 19,
        name: '一週風力報表_台灣至南沙',
        grid_dir: ['composite_fig/wind/NS/'],
        use_fulldate: true,
        data_template: [
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: 'NCEP_NAGRID_NS_',
                        suffix: '_AR2',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ]
    },
    {
        image_type: 20,
        name: '一週波浪預報_台灣至沖之島',
        grid_dir: ['composite_fig/wave/PV/'],
        use_fulldate: true,
        data_template: [
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: 'MCGA_MM01_PV_',
                        suffix: '_WAVEH',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ]
    },
    {
        image_type: 21,
        name: '一週波浪預報_台灣至南沙',
        grid_dir: ['composite_fig/wave/NS/'],
        use_fulldate: true,
        data_template: [
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: 'MCGA_MM01_NS_',
                        suffix: '_WAVEH',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ]
    },
    {
        image_type: 22,
        name: '南沙一週預報',
        grid_dir: ['composite_fig/NanSha/'],
        use_fulldate: true,
        data_template: [
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_suf',
                        prefix: 'TMSQ_NS__',
                        suffix: '_MCGA1W',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ]
    },

    // TRA
    {
        image_type: 14,
        data_template: [
            { tag: 'multiple-chart', zone_span: '路線', option_local_storage_name: 'route_atlas_option' }
        ]
    },
    {
        image_type: 15,
        data_template: [
            { tag: 'multiple-chart', zone_span: '工務段', option_local_storage_name: 'branch_atlas_option' }
        ]
    },
    {
        image_type: 16,
        data_template: [
            { tag: 'multiple-chart', zone_span: '分駐所', option_local_storage_name: 'station_atlas_option' }
        ]
    },
    {
        image_type: 10,
        name: '短期預報雨量圖(0~24HR)',
        data_template: [
            {
                tag: 'time-select-table',
                text: '短期預報雨量圖(0~24HR)',
                titles: ["00-03", "00-06", "00-09", "00-12", "00-15", "00-18", "00-21", "00-24"],
                dir: 'qpf4tra/PCP2D/',
                kind: ['ENS', 'MIC', 'M04'],
                path_use_kind: true,
                prefix: 'PCP2D',
                type: 'jpg'
            },
        ]
    },
    {
        image_type: 11,
        name: '24小時與72小時累積雨量圖',
        data_template: [
            {
                tag: 'time-select-table',
                text: '24小時與72小時累積雨量圖',
                titles: ["00-12", "00-24", "06-30", "24-48", "30-54", "48-72", "00-72"],
                kind: ['MFC', 'MIC', 'PM0'],
                path_use_kind: true,
                dir: 'qpf4tra/PCP2D/',
                prefix: 'PCP2D',
                type: 'jpg'
            },
        ]
    },
    {
        image_type: 12,
        name: '24小時鐵路沿線累積雨量圖',
        data_template: [
            {
                tag: 'time-select-table',
                text: '24小時鐵路沿線累積雨量圖',
                titles: ["00-12", "00-24", "06-30", "24-48", "30-54", "48-72", "00-72"],
                kind: ['MFC', 'MIC', 'PM0'],
                path_use_kind: true,
                dir: 'qpf4tra/Single/',
                prefix: 'Single',
                type: 'png'
            },
        ]
    },
    {
        image_type: 13,
        name: '颱風路徑圖',
        data_template: [
            {
                tag: 'time-select-table',
                text: '颱風路徑圖',
                titles: ["00-03", "00-06", "00-09", "00-12", "00-15", "00-18", "00-21", "00-24"],
                kind: ['ETQPF'],
                path_use_kind: false,
                dir: 'qpf4tra/ETQPFTracks',
                prefix: 'ETQPFTracks',
                path_rule: 'date_time-pre-title',
                type: 'jpg'
            },
        ]
    },
    {
        image_type: 26,
        name: '乾旱指標_衛星反衍NDVI距平',
        grid_dir: ['wra/monthly/satellite/'],
        data_template: [
            {
                tag: 'title',
                text: '衛星反衍產品',
            },
            {
                tag: 'subtitle',
                titles: ['NDVI距平'],
                title_en: ''
            },
            {
                tag: 'grid-left-right',
                images_left: [
                    {
                        src:  '',
                        rule: 'wra_droughtindex',
                        suffix:  'NDVI_m_anom_',
                        dir_index: 0,
                        type: 'jpg',
                        failed: false,
                        alt_image: alt_src,
                    }
                ],
                images_right: [
                    {
                        src:  '',
                        rule: 'wra_droughtindex',
                        suffix:  'ts_ndvi_ave_',
                        dir_index: 0,
                        type: 'jpg',
                        failed: false,
                        alt_image: alt_src,
                    }
                ]
            }
        ]
    },
    {
        image_type: 32,
        name: '乾旱指標_水庫集水區SPI',
        grid_dir: ['wra/monthly/SPI/'],
        data_template: [
            {
                tag: 'title',
                text: '氣象乾旱指標即時監測',
            },
            {
                tag: 'subtitle',
                titles: ['　'],
                title_en: ''
            },
            {
                tag: 'grid',
                grid: 4,
                images: [
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'TaiSA_',
                        middle: '',
                        suffix: '_1mn_SPI3_all',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '3個月氣象乾旱指標(SPI3)'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'TaiSA_',
                        middle: '',
                        suffix: '_1mn_SPI6_all',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '6個月氣象乾旱指標(SPI6)'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'TaiSA_',
                        middle: '',
                        suffix: '_1mn_SPI12_all',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '12個月氣象乾旱指標(SPI12)'
                    },
                    {
                        src:  '',
                        rule: 'pre_year_month_suf',
                        prefix: 'TaiSA_',
                        middle: '',
                        suffix: '_1mn_SPI3612_all',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        header_content: '3、6、12個月氣象乾旱指標'
                    }
                ]
            }
        ]
    },
    {
        image_type: 27,
        name: 'ECMWF',
        grid_dir: ['wra/weekly/TyphoonPotential/ECMWF/'],
        data_template: [
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_hour_suf',
                        prefix: 'Cluster_Area_Image_',
                        suffix: '_ECMWF_all',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'help-icon',
                image: {
                    alt: '颱風1-4週侵襲潛勢預報說明',
                    src: '/static/images/product/atlas_description/typhoonForecastWeek1to4.png',
                    width: '80%'
                }
            },
        ]
    },
    {
        image_type: 28,
        name: 'NCEP',
        grid_dir: ['wra/weekly/TyphoonPotential/NCEP/'],
        data_template: [
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'pre_date_hour_suf',
                        prefix: 'Cluster_Area_Image_',
                        suffix: '_NCEP_all',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ]
    },
    //MPB航港局
    {
        image_type: 33,
        name: '台灣海域警戒',
        data_template: [
            {
                tag: 'title',
                text: '台灣海域警戒'
            },
            {
                tag: 'date-single-table',
                row_date_count: 8,
                column_date_count: 5,
                images_dir: 'mpb/fig',
                images_dir: 'mpb/warning',
                file_name: {
                    rule: 'year_date_pre_index_suf',
                    prefix: '00CST_MPB_Warning_Area_Taiwan_tau',
                    suffix: '',
                    type: 'png'
                },
                compression: false
            }
        ]
    },
    //REQPN
    {
        image_type: 34,
        name: '未來三小時雷達系集定量降雨預報',
        grid_dir: [
            'REQPN/REQPN_fst/',
        ],
        data_template: [
            {
                tag: 'title',
                text: '未來三小時雷達系集定量降雨預報',
            },
            {
                tag: 'datetime-select'
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        utc: 0, //設定資料時區
                        format:'[REQPN.]YYYYMMDD.HHmm', //REQPN.20260415.0500.png
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ],
    },
    {
        image_type: 35,
        name: '雷達系集定量降雨預報0-1小時校驗',
        grid_dir: [
            'REQPN/REQPN_Verification/',
        ],
        data_template: [
            {
                tag: 'title',
                text: '雷達系集定量降雨預報0-1小時校驗',
            },
            {
                tag: 'datetime-select',
                add_mins: -10 //預設時間 = 資料時間 + add_mins
            },
            {
                tag: 'subtitle',
                titles: ['觀測與預報累積雨量結果'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'[Verifi_REQPN_0_1H.]YYYYMMDD.HHmm', //Verifi_REQPN_0_1H.20260415.0200.png
                        utc: 0, //設定資料時區
                        add_mins: -60, //所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['鄰域空間檢驗方法(Fractions Skill Score,FSS)分數'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.fss_0_1H]', //20260415.0000.fss_0_1H.png
                        utc: 0, //設定資料時區
                        add_mins: -60,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['公正預兆得分(Equitable Threat Score, ETS)', '偏離係數(BIAS)與QPE面積比例時序圖：降雨門檻0.5mm'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.categ_QPEgrid_0_1H_thr0.5]', //20260415.0000.categ_QPEgrid_0_1H_thr0.5.png
                        utc: 0, //設定資料時區
                        add_mins: -60,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['公正預兆得分(Equitable Threat Score, ETS)', '偏離係數(BIAS)與QPE面積比例時序圖：降雨門檻20mm'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.categ_QPEgrid_0_1H_thr20.0]', //20260415.0000.categ_QPEgrid_0_1H_thr20.0.png
                        utc: 0, //設定資料時區
                        add_mins: -60,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['公正預兆得分(Equitable Threat Score, ETS)', '偏離係數(BIAS)與QPE面積比例時序圖：降雨門檻40mm'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.categ_QPEgrid_0_1H_thr40.0]', //20260415.0000.categ_QPEgrid_0_1H_thr40.0.png
                        utc: 0, //設定資料時區
                        add_mins: -60,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ],
    },
    {
        image_type: 36,
        name: '雷達系集定量降雨預報0-2小時校驗',
        grid_dir: [
            'REQPN/REQPN_Verification/',
        ],
        data_template: [
            {
                tag: 'title',
                text: '雷達系集定量降雨預報0-2小時校驗',
            },
            {
                tag: 'datetime-select',
                add_mins: -10 //預設時間 = 資料時間 + add_mins
            },
            {
                tag: 'subtitle',
                titles: ['觀測與預報累積雨量結果'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'[Verifi_REQPN_0_2H.]YYYYMMDD.HHmm', //Verifi_REQPN_0_2H.20260415.0200.png
                        utc: 0, //設定資料時區
                        add_mins: -120,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['鄰域空間檢驗方法(Fractions Skill Score,FSS)分數'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.fss_0_2H]', //20260415.0000.fss_0_2H.png
                        utc: 0, //設定資料時區
                        add_mins: -120,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['公正預兆得分(Equitable Threat Score, ETS)', '偏離係數(BIAS)與QPE面積比例時序圖：降雨門檻0.5mm'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.categ_QPEgrid_0_2H_thr0.5]', //20260415.0000.categ_QPEgrid_0_2H_thr0.5.png
                        utc: 0, //設定資料時區
                        add_mins: -120,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['公正預兆得分(Equitable Threat Score, ETS)', '偏離係數(BIAS)與QPE面積比例時序圖：降雨門檻20mm'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.categ_QPEgrid_0_2H_thr20.0]', //20260415.0000.categ_QPEgrid_0_2H_thr20.0.png
                        utc: 0, //設定資料時區
                        add_mins: -120,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['公正預兆得分(Equitable Threat Score, ETS)', '偏離係數(BIAS)與QPE面積比例時序圖：降雨門檻40mm'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.categ_QPEgrid_0_2H_thr40.0]', //20260415.0000.categ_QPEgrid_0_2H_thr40.0.png
                        utc: 0, //設定資料時區
                        add_mins: -120,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ],
    },
    {
        image_type: 37,
        name: '雷達系集定量降雨預報0-3小時校驗',
        grid_dir: [
            'REQPN/REQPN_Verification/',
        ],
        data_template: [
            {
                tag: 'title',
                text: '雷達系集定量降雨預報0-3小時校驗',
            },
            {
                tag: 'datetime-select',
                add_mins: -10 //預設時間 = 資料時間 + add_mins
            },
            {
                tag: 'subtitle',
                titles: ['觀測與預報累積雨量結果'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'[Verifi_REQPN_0_3H.]YYYYMMDD.HHmm', //Verifi_REQPN_0_3H.20260415.0200.png
                        utc: 0, //設定資料時區
                        add_mins: -180,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['鄰域空間檢驗方法(Fractions Skill Score,FSS)分數'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.fss_0_3H]', //20260415.0000.fss_0_3H.png
                        utc: 0, //設定資料時區
                        add_mins: -180,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['公正預兆得分(Equitable Threat Score, ETS)', '偏離係數(BIAS)與QPE面積比例時序圖：降雨門檻0.5mm'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.categ_QPEgrid_0_3H_thr0.5]', //20260415.0000.categ_QPEgrid_0_3H_thr0.5.png
                        utc: 0, //設定資料時區
                        add_mins: -180,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['公正預兆得分(Equitable Threat Score, ETS)', '偏離係數(BIAS)與QPE面積比例時序圖：降雨門檻20mm'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.categ_QPEgrid_0_3H_thr20.0]', //20260415.0000.categ_QPEgrid_0_3H_thr20.0.png
                        utc: 0, //設定資料時區
                        add_mins: -180,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
            {
                tag: 'subtitle',
                titles: ['公正預兆得分(Equitable Threat Score, ETS)', '偏離係數(BIAS)與QPE面積比例時序圖：降雨門檻40mm'],
                title_en: '',
                update_messages: []
            },
            {
                tag: 'grid',
                grid: 1,
                images: [
                    {
                        src:  '',
                        rule: 'dayjs_format',
                        format:'YYYYMMDD.HHmm[.categ_QPEgrid_0_3H_thr40.0]', //20260415.0000.categ_QPEgrid_0_3H_thr40.0.png
                        utc: 0, //設定資料時區
                        add_mins: -180,//所選時間 + add_mins = 檔名時間
                        prefix: '',
                        suffix: '',
                        dir_index: 0,
                        type: 'png',
                        failed: false,
                        alt_image: alt_src,
                        center: true
                    }
                ]
            },
        ],
    },
]
